import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { VideoDataService } from '../services/video-data.service';

export const landingGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const videoDataService = inject(VideoDataService);
  const router = inject(Router);

  if (videoDataService.getVideoData()) {
    return true;
  }

  const id = route.queryParamMap.get('id');
  return router.createUrlTree(['/login'], id ? { queryParams: { id } } : {});
};
